export default __webpack_public_path__ + "static/media/uimg2.f7414ee6.webp";